import { Box, Button, Stack, Typography } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useResponsive } from '../hooks/useResponsive'

export function DateSelector({
  startDate,
  endDate,
  onDateChange,
  onStartDateChange,
  onEndDateChange,
}) {
  const { isMobile } = useResponsive()
  const [localStartDate, setLocalStartDate] = useState(dayjs(startDate || new Date()))
  const [localEndDate, setLocalEndDate] = useState(dayjs(endDate || new Date()))

  const handleApply = () => {
    if (onDateChange) {
      onDateChange(localStartDate, localEndDate)
    } else if (onStartDateChange && onEndDateChange) {
      onStartDateChange(localStartDate)
      onEndDateChange(localEndDate)
    } else if (onStartDateChange) {
      onStartDateChange(localStartDate)
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ mb: 3 }}>
        <Typography variant='overline' sx={{ mb: 1, display: 'block', color: 'text.secondary' }}>
          Select Date Range
        </Typography>
        <Stack
          direction={isMobile ? 'column' : 'row'}
          spacing={2}
          alignItems={isMobile ? 'stretch' : 'center'}
        >
          <DatePicker
            label='Start Date'
            value={localStartDate}
            onChange={(newValue) => setLocalStartDate(newValue)}
            slotProps={{
              textField: {
                size: 'small',
                fullWidth: isMobile,
              },
            }}
            maxDate={localEndDate}
          />
          {endDate !== undefined && (
            <DatePicker
              label='End Date'
              value={localEndDate}
              onChange={(newValue) => setLocalEndDate(newValue)}
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: isMobile,
                },
              }}
              minDate={localStartDate}
            />
          )}
          <Button
            variant='contained'
            color='primary'
            onClick={handleApply}
            size='small'
            fullWidth={isMobile}
          >
            Apply
          </Button>
        </Stack>
      </Box>
    </LocalizationProvider>
  )
}

// PropTypes for type checking
DateSelector.propTypes = {
  startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onDateChange: PropTypes.func,
  onStartDateChange: PropTypes.func,
  onEndDateChange: PropTypes.func,
}
